export default {
  records: {
    loading: 'Loading…',
    loadMore: 'Load More',
    empty: 'No claim records for this period',
    footer: 'Only showing records from the last 7 days',

    filterCategory: 'Type',
    filterTime: 'Time',

    category: {
      all: 'All',
      promotions: 'Promos',
      tasks: 'Tasks',
      vipSalary: 'VIP Salary',
      rakeback: 'Live Rakeback',
      referral: 'Referral commission',
    },

    module: {
      promotions: 'Promotions',
      tasks: 'Reward Tasks',
      vipSalary: 'VIP Salary',
      rakeback: 'Rebate',
    },

    vipType: {
      DAILY: 'Daily Salary',
      WEEKLY: 'Weekly Salary',
      MONTHLY: 'Monthly Salary',
      UPGRADE: 'Upgrade Bonus',
    },

    vipSalaryDefault: 'Salary',
    taskLevel: '{title} · Lv.{stage}',
    rakebackTitle: 'Rebate · {name}',
    rakebackDefault: 'Rebate',
  },

  rebate: {
    historyTotal: 'Total Claimed',
    rulesLabel: 'Rules',
    claimableLabel: 'Rakeback available now',
    claimNow: 'Claim now {amount}',
    claimed: 'Claimed ✓',
    nextPayout: '⏳ Next payout in {countdown}',
    claimSucceeded: 'Rebate claimed {amount}',
    claimPending: 'Rebate claim accepted, crediting {amount}',
    claimFailed: 'Claim failed, please try again later',
    validBet: 'Valid Bet {amount}',
    currentRate: 'Rate {rate}%',
    rulesTitle: 'Rebate Rules',
    rateDetailTitle: 'Rebate Rate Details',
    filterGameType: 'Game Type',
    filterVendor: 'Vendor',
    baseMatrix: 'Base Matrix',
    vipLevel: 'VIP Level',
    totalDeposit: 'Total Deposit',
    rebateRate: 'Rebate Rate',
    loading: 'Loading…',
    rateNote:
      'Rebate rates increase with VIP level. The table above shows real-time rates for the current vendor and takes effect immediately after upgrade.',
    ruleRatioTitle: 'Rakeback rates',
    ruleRatio1:
      'By <b>valid bet volume</b> rakeback is computed live; the rate varies by game type and provider: slots up to <b>1.0%</b>, fishing up to <b>0.7%</b>, live up to <b>0.6%</b>, cards up to <b>0.5%</b>, sports up to <b>0.38%</b>.',
    ruleRatio2:
      'Higher VIP levels earn higher rakeback; the live rate shown per provider on the Live Rakeback page prevails.',
    ruleDistributeTitle: 'Payout rules',
    ruleDistribute1: 'After valid bets are made, <b>50% pays out</b>, claimable immediately.',
    ruleDistribute2: 'The remaining 50% pays out <b>12.5% every 2 hours</b>, 8 payouts in total.',
    ruleDistribute3: 'Rakeback has <b>no cap</b> — the more you bet, the more you get back.',
    ruleClaimTitle: 'Settlement & Claiming',
    ruleClaim1: "Valid bets accrue live; the previous day's data is settled at 00:00{note}.",
    ruleClaim2:
      'Rakeback is under Rewards · Live Rakeback, <b>claimed manually</b>; unclaimed rakeback keeps accruing and never expires.',
    ruleClaim3: 'Claimed rakeback requires <b>{n}× wagering</b> before it can be withdrawn.',
    ruleClaimFree:
      'Claimed rakeback has <b>no wagering requirement</b> and goes straight to your available balance.',
    ruleClaim4: 'Hedging, wash-betting and other invalid bets earn no rakeback.',
    all: 'All',
    gameType: {
      original: 'Original',
      slots: 'Slots',
      card: 'Card',
      live: 'Live',
      lottery: 'Lottery',
      fish: 'Fishing',
      sport: 'Sports',
      esport: 'Esports',
    },
  },

  vip: {
    loading: 'Loading...',
    loadError: 'Failed to load, please try again later',
    retry: 'Retry',
    claimReceived: '{label} {amount} credited to balance',
    claimProcessing: '{label} {amount} claimed, crediting shortly',

    cardType: {
      UPGRADE: 'Upgrade Bonus',
      DAILY: 'Daily Salary',
      WEEKLY: 'Weekly Salary',
      MONTHLY: 'Monthly Salary',
    },

    action: {
      AVAILABLE: 'Claim',
      PROCESSING: 'Processing',
      CLAIMED: 'Claimed ✓',
      EXPIRED: 'Expired',
      LOCKED_WITH_DATE: '{date} available',
      LOCKED_COUNTDOWN: 'Opens in {countdown}',
      LOCKED_NO_DATE: 'Not open',
      DISABLED: 'Unavailable',
    },

    hero: {
      currentLevel: 'Current Level',
      rules: 'Rules',
      maxLevel: 'Max level reached',
      nextLevel: 'V{level} to go · deposit',
    },

    benefit: {
      title: '📊 Level Benefits',
      hint: '{total} levels · scroll',
      level: 'Level',
      totalDeposit: 'Total Deposit',
      upgradeBonus: 'Upgrade Bonus',
      dailyBonus: 'Daily Salary',
      weeklyBonus: 'Weekly Salary',
      monthlyBonus: 'Monthly Salary',
    },

    rules: {
      title: 'VIP Salary Rules',
      levelAndUpgradeTitle: 'Level & Upgrade',
      levelAndUpgrade1:
        'VIP levels are upgraded automatically based on <b>total valid deposits</b>, <b>only the deposit amount counts, no wagering required</b>; reach the threshold to upgrade instantly.',
      levelAndUpgrade2:
        'Upon upgrading, the corresponding <b>upgrade bonus</b> is issued instantly, with a total of <b>50</b> levels. Higher levels yield richer bonuses (V18 {amount18} / up to V50 {amount50}).',
      levelAndUpgrade3:
        'Each tier only grants the upgrade bonus once on the <b>first achievement</b>; multi-tier upgrades pay the highest tier in one lump sum.',
      retentionTitle: 'Retention Rules',
      retention1:
        'After claiming daily / weekly / monthly salary, you must complete <b>10× the claimed amount</b> in valid wagering within the cycle to retain your level.',
      retention2:
        "Example: this month's total claimed salary is {amount1}, you must complete ≥ {amount2} valid wagering, otherwise you will drop 1 level next month.",
      retention3:
        "<b>Uncollected salary cycles are not evaluated and will not cause demotion</b> — if you don't want to wager, you may skip claiming salary and keep your current level.",
      paymentTitle: 'Salary Payout',
      payment1:
        '<b>Daily Salary</b>: refreshes at 00:00{note} every day, must be claimed manually the same day; no make-up for missed claims.',
      payment2:
        '<b>Weekly Salary</b>: opens at 00:00{note} every Monday, can be claimed within the week.',
      payment3:
        '<b>Monthly Salary</b>: opens at 00:00{note} on the 1st of each month, can be claimed within the month.',
      payment4:
        'Salary amounts are paid based on your current VIP level; from the next day after upgrade, the new level rate applies.',
      claimTitle: 'Claim & Withdrawal',
      claim1:
        'All salaries and bonuses must be claimed manually in 「Rewards · VIP Salary」; the system does not auto-issue them.',
      claim2: 'Claimed reward funds require <b>1× turnover</b> before withdrawal.',
      claim3:
        'Hedging, arbitrage and other violations are prohibited; offenders will have VIP status revoked and rewards clawed back. The platform reserves the final right of interpretation.',
    },
  },

  daily: {
    stageLabel: 'Stage {no}',
    claimAllPartial: 'Claimed {amount}, some stages still processing',
    claimAll: 'Claimed all {amount}',
    claimLevelClaimed: 'Claimed {amount}',
    claimLevelProcessing: 'Processing {amount}',
    claimLevelChallenge: 'Please complete verification',
    claimLevelPending: 'Claim result pending',
    bannerLabel: "Today's claimable rewards",
    claimAllButton: 'Claim all',
    claimedOutButton: 'All claimed today',
    currentDeposit: 'Current deposit',
    currentCount: 'Current progress',
    currentBet: 'Current bet',
    nextStage: 'Next stage',
    completed: 'Completed',
    requirementDeposit: 'Deposit',
    requirementCount: 'Target',
    requirementBet: 'Bet',
    typeBetTurnover: 'Turnover',
    typeBetCount: 'Bet count',
    typeDeposit: 'Deposit',
    typeLogin: 'Login days',
    typePlayGame: 'Play game',
    unitRound: 'rounds',
    unitDay: 'days',
    currentOf: 'Current {name}',
    statusClaimed: '✓ Claimed',
    statusClaimable: 'Claim',
    statusProgress: 'In progress',
    statusLocked: 'Locked',
    claimSuccessToast: 'Claimed {amount}',
  },

  acts: {
    loading: 'Loading…',
    empty: 'No promotions',
    detailTitle: 'Promotion',
    todayAvailable: 'Available today',
    waitingDays: '{days}d to go',
    waitingBirthday: 'Birthday in {days}d',
    remainingDays: '{days}d left',
    achievedDays: '{days}d streak',
    claimSuccess: 'Claimed',
    claimProcessing: 'Processing, check back later',
    claimFailed: 'Claim failed, please try again later',
    unsupportedResource: 'Unsupported link',
    birthdayTitle: 'Set Birthday',
    birthdayHint: 'Your birthday cannot be changed once set. Please confirm before submitting.',
    birthdayConfirm: 'Confirm',
    birthdaySet: 'Birthday set',
    status: {
      UNSET: 'Not set',
      INCOMPLETE: 'Incomplete',
      WAITING: 'Waiting',
      IN_PROGRESS: 'In progress',
      CLAIMABLE: 'Claimable',
      CLAIM_PROCESSING: 'Processing',
      CLAIMED: 'Claimed',
      EXPIRED: 'Expired',
    },
    action: {
      UNSET: 'Set now',
      DEPOSIT: 'Deposit',
      WITHDRAW: 'Withdraw',
      GAME: 'Play now',
      SET_BIRTHDAY: 'Set now',
      CLAIM: 'Claim',
      OPEN_RESOURCE: 'Open',
      AUTO: 'Auto crediting',
      NONE: '—',
    },
    detail: {
      secDetail: 'Details',
      secRules: 'Rules',
      listSep: ', ',
      clauseSep: '; ',
      rowDesc: 'Description',
      rowTrigger: 'Trigger',
      rowRequire: 'Eligibility',
      rowChannel: 'Wallet types',
      rowCurrency: 'Currencies',
      rowDepositReq: 'Deposit requirement',
      rowSchedule: 'Schedule',
      rowCalc: 'Method',
      rowScope: 'Games',
      rowThreshold: 'Minimum',
      rowStreakWeek: 'Weekly streak',
      rowStreakMonth: 'Monthly streak',
      rowStreakWeekPrize: 'Weekly reward',
      rowStreakMonthPrize: 'Monthly reward',
      rowMethod: 'Reward type',
      rowAmount: 'Reward amount',
      rowCap: 'Reward cap',
      rowClaimWay: 'Claim',
      rowValidity: 'Valid for',
      rowCount: 'Claim limit',
      rowWager: 'Wagering',
      rowRewardRange: 'Reward range',
      rowNote: 'Notes',
      viaType: ' via [{type}]',
      channelTypesEtc: '{types} and others',
      reqAmount: ' of at least {amount}',
      reqWithdraw: ' of at least {amount}',
      weeklyPrefix: 'On {days}',
      monthlyPrefix: 'On day {days} of each month',
      dayOfMonth: '{d}',
      weekday: {
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
        7: 'Sun',
      },
      hlReward: 'Reward {amount}',
      hlRewardTop: 'Reward up to {amount}',
      methodFixed: 'Fixed amount',
      methodRatePlain: '{rate} of {base}',
      methodTiered: 'Paid by qualifying tier',
      methodTracks: 'Tiered fixed amount',
      methodVip: 'Fixed amount by King level',
      baseDeposit: 'deposit amount',
      baseWithdraw: 'withdrawal amount',
      baseLoss: 'loss amount',
      baseBet: 'bet amount',
      baseWin: 'win amount',
      basePayout: 'payout amount',
      baseReturn: 'return deposit amount',
      baseTicket: 'bet amount',
      baseMultiplier: 'win multiplier',
      capTop: 'Up to {amount}',
      capTopDaily: 'Up to {amount}/day',
      minDeposit: 'Minimum deposit {amount}',
      reqChannelType: 'Deposit via {type}',
      reqChannelTypeMin: 'Deposit via {type}, minimum {amount}',
      unitYuan: 'CNY',
      tierRow: 'Reaching {threshold}: {value}',
      tierRandom: 'random {min} ~ {max}',
      vipRange: 'Bonus by VIP level ({min} ~ {max})',
      rewardVipTable: 'Bonus is paid by VIP level',
      targetAvailable: 'Reward is credited to the available balance',
      targetBonus:
        'Reward is credited to the bonus balance; withdrawable after the wagering requirement',
      wagering: 'Withdrawable after {n}x wagering',
      ruleTarget: 'Eligible users: {v}',
      ruleClaimManual:
        'Rewards must be claimed manually in the Rewards Center; they are not credited automatically.',
      ruleClaimAuto: 'Rewards are credited automatically once you qualify.',
      ruleValidity: 'Claim window: {v}.',
      ruleWager: 'Rewards require {n}x wagering before withdrawal.',
      ruleDisclaimer:
        'The platform reserves the right of final interpretation. Abuse is prohibited; violators will be disqualified and rewards recovered.',
      claimManual: 'Manual claim in Rewards Center',
      claimAuto: 'Auto-credited on qualifying',
      validityDeposit: 'Claim within {d} days after the deposit; expires afterwards',
      validityWithdraw: 'Claim within {d} days after the withdrawal; expires afterwards',
      validityDays: 'Claim within {d} days of qualifying; expires afterwards',
      validityHours: 'Claim within {h} hours of qualifying; expires afterwards',
      limitLifetime: 'Lifetime limit: {n}',
      limitPerWallet: '{n} per wallet type',
      limitDaily: '{n} per day',
      limitDailyPerDay: '{n} per event day',
      limitMemberDay: '{n} per member day',
      limitYearly: '{n} per year',
      limitStreakBoth: 'Once per week/month',
      limitStreakWeekly: 'Once per week',
      limitStreakMonthly: 'Once per month',
      streakCondDays: 'deposits on {n} consecutive days',
      streakCondAny: 'a deposit every day',
      streakCondGe: ' ≥ {amount}',
      streakWeekRow: 'Last week {cond}; claimable this Monday',
      streakMonthRow: 'Last month {cond}; claimable on the 1st this month',
      scopeGames: 'Games: {names}',
      scopeCategories: 'Game types: {names}',
      scopeVendors: 'Providers: {names}',
      scopeAll: 'All games are eligible',
      scopeAllCat: 'All {name}',
      scopeConfigurable: ' (specific games configurable)',
      amountRange: '{min} - {max}',
      noteBirthday: 'Birthday must be set in your profile and cannot be changed later',
      validityBirthday: 'Within {h} hours on your birthday',
      thresholdMult: '{metric} ≥ {v}x',
      thresholdAmtGe: '{metric} ≥ {amount}',
      rule: {
        trigDepositSeq: 'When the user completes deposit #{n}',
        trigFirstWithdraw: 'When the user completes the first successful withdrawal',
        trigRegMilestone: '{days} days after registration',
        trigChannelFirst: 'On the first deposit via a designated wallet',
        trigChannelNamed: 'On the first deposit via {type}',
        trigDaily: 'When the user completes the first deposit of the day',
        trigDate: 'On a deposit made on set dates',
        trigDateOn: 'On a deposit made {days}',
        trigBet: 'After {metric} qualifies',
        trigBetExtreme: "Claimable today (based on yesterday's data)",
        trigLossRescue: "Claimable today (based on yesterday's data)",
        trigLoss: "After yesterday's net loss qualifies",
        trigStreak: 'After daily deposits qualify for the last full period',
        trigBirthday: 'On your birthday',
        trigComeback: 'When an eligible user completes the first deposit after returning',
        reqDepositFirst: 'Newly registered user, lifetime deposits = 0',
        reqDepositSecond: 'First deposit completed, lifetime deposits = 1',
        reqDepositThird: 'Second deposit completed, lifetime deposits = 2',
        reqDepositNth: 'Deposit #{c} completed, lifetime deposits = {c}',
        reqMinDeposit: ', single deposit of at least {amount}',
        reqMinWithdraw: ', single withdrawal of at least {amount}',
        reqFirstWithdraw: 'Within {days} days of registration, lifetime withdrawals = 0',
        reqFirstWithdrawAny: 'Lifetime withdrawals = 0',
        reqRegMilestone: 'Registered for {days} days',
        reqRegCum: ', cumulative deposits >= {amount}',
        reqChannelFirst: 'Lifetime deposits via this wallet channel = 0',
        reqLossRescue: 'Net loss yesterday ≥ {amount}',
        reqLossRescueAny: 'Net loss yesterday',
        reqLossRescueScoped: 'Net loss on {scope} yesterday ≥ {amount}',
        reqLossRescueScopedAny: 'Net loss on {scope} yesterday',
        reqChannelNamed: 'Lifetime deposits via {type} channel = 0',
        reqDailyDeposit: 'No deposit yet today (resets daily at 00:00)',
        reqBirthdayVip: 'Birthday set, King level ≥ {level}',
        reqBirthdayAny: 'Birthday set',
        reqComebackAmt: 'Lifetime deposits ≥{amount}',
        reqComebackCount: 'Lifetime deposit count ≥{n}',
        reqComebackNoDep: 'No deposit in the last {days} days',
        reqComebackNoGame: 'No gameplay in the last {days} days',
        reqComebackAny: 'Returning users',
        birthdayNote: 'Birthday must be set in your profile and cannot be changed later.',
        depositSeq: 'Your {n}th successful deposit{req} earns the reward.',
        depositSeqNote:
          'If that deposit misses the threshold, later deposits will not count as that ordinal.',
        depositSeqBase: 'Rate rewards are based on the amount of the {n}th deposit.',
        withinDays: 'Within {days} days of registration, ',
        firstWithdraw: '{within}your first successful withdrawal{req} earns the reward.',
        firstWithdrawNote:
          'If the first withdrawal misses the threshold, later withdrawals will not count as the first.',
        firstWithdrawBase: 'Rate rewards are based on the first withdrawal amount.',
        andCumDeposit: ' with cumulative deposits of at least {amount}',
        regMilestone: 'Registered for {days} days{cum}, earns the reward.',
        regMilestoneTier:
          'Tiered rewards are picked by cumulative lifetime deposits at the time of qualifying; tiers do not stack.',
        channelFirst: 'Your first successful deposit{req} via [{type}] earns the reward.',
        channelFirstNote:
          'Different wallets or channels under the same deposit type do not each get a first deposit.',
        dailyDeposit:
          'The first successful deposit each day{req} earns the reward, by site calendar day.',
        dailyDepositNote:
          "If the day's first deposit misses the threshold, later deposits will not count as the first of the day.",
        dailyDepositBase: "Rate rewards are based on the day's first deposit amount.",
        dateDeposit: 'A successful deposit{req}{type} {days} earns the reward.',
        dateDepositNote:
          'Each event day qualifies independently; multiple deposits on the same day do not stack.',
        dateDepositBase: 'Rate rewards are based on the qualifying single deposit amount.',
        metric: {
          BET_AMOUNT: "yesterday's largest single bet",
          WIN_AMOUNT: "yesterday's largest single payout",
          MULTIPLIER: "yesterday's highest single win multiplier",
        },
        thresholdX: 'reaching {v}x ',
        thresholdAmt: 'reaching {amount} ',
        metricShort: {
          BET_AMOUNT: 'single bet amount',
          WIN_AMOUNT: 'win amount',
          MULTIPLIER: 'win multiplier',
        },
        calcBetExtreme: "Take yesterday's ticket with the highest {metric}",
        betExtreme: '{metric} {th}earns the reward.',
        betExtremeNote:
          'Only settled bets from yesterday are counted; eligibility is granted after daily settlement.',
        lossRescue: 'A net loss {th}within the eligible scope yesterday earns a rescue reward.',
        lossRescueNote:
          'Net loss offsets winnings against losses; eligibility is granted after daily settlement.',
        streakDaily: 'with daily deposits of at least {amount}',
        streakDailyAny: 'with a successful deposit every day',
        streakPrize: ', earning {amount}',
        streakWeekly:
          'Weekly track: deposit {daily} every day last calendar week (Mon-Sun){prize}. Settlement starts this Monday; claim within this week, once per period.',
        streakMonthly:
          'Monthly track: deposit {daily} every day last calendar month{prize}. Month length follows the calendar; settlement starts on the 1st; claim within this month, once per period.',
        birthdayVip: 'VIP {level} and above: ',
        birthday: '{vip}qualify on your birthday to receive a birthday bonus.',
        birthdaySet: 'Set your birthday in Me -> Profile; it cannot be changed afterwards.',
        silenceDeposit: 'no deposit for {days} days',
        silenceGame: 'no gameplay for {days} days',
        lifeDepositAmt: 'lifetime deposits of at least {amount}',
        lifeDepositCount: 'at least {n} lifetime successful deposits',
        comeback:
          'Return conditions: {conds}; all must be met, and history excludes the return deposit.',
        comebackGeneric: 'Meet the return conditions to earn the reward.',
        comebackDeposit: 'A return deposit of at least {amount} triggers the reward.',
        comebackBase: 'Rate rewards are based on the return deposit amount.',
      },
    },
  },
}
